/**
 * #4 Partner Programme application — /landing/partner-programme.
 * Lands in the Partner layout so the partner team works it.
 */
import { Link } from "react-router-dom";
import analytics from "@/utils/analytics";
import { company, email, firstName, lastName, phone, website } from "./common";

const opt = (label, crm) => ({ value: label, label, crm });

/** Business type → Zoho Partner_Type (Consultant, EPOS, Developer,
 *  Lead Generator, Affiliate, Agency). Unmapped types stay in the Note. */
const BUSINESS_TYPES = [
  opt("Ecommerce Agency", "Agency"),
  opt("Web Developer", "Developer"),
  opt("Shopify Developer", "Developer"),
  opt("WooCommerce Developer", "Developer"),
  opt("Freelance Developer", "Developer"),
  opt("Consultant", "Consultant"),
  opt("SaaS Provider", null),
  opt("Technology Partner", null),
  opt("Business Network", "Lead Generator"),
  opt("Other", null),
];

const CLIENT_COUNTS = ["1–5", "6–10", "11–25", "26–50", "51–100", "100+"].map((l) => opt(l));
const WORKS_WITH_UK = ["Yes, regularly", "Yes, occasionally", "Not currently, but planning to", "No"].map((l) => opt(l));
const MAIN_PLATFORMS = [
  "Shopify", "WooCommerce", "Magento", "Custom ecommerce", "Retail", "Hospitality",
  "Services", "Mixed client base", "Other",
].map((l) => opt(l));

const partnerApplication = {
  id: "partner_application",
  label: "Partner Programme application",
  crm: { layout: "Partner", leadSource: "Website Partner Enquiry", tags: ["Partner application"] },
  fields: [
    [firstName, lastName],
    { ...company, label: "Company" },
    [email, phone],
    { ...website, name: "partner_website" },
    [
      { name: "business_type", type: "select", label: "Business type", options: BUSINESS_TYPES, crm: "Partner_Type" },
      { name: "client_count", type: "select", label: "Approximate client count", options: CLIENT_COUNTS },
    ],
    [
      { name: "works_with_uk", type: "select", label: "Do you currently work with UK merchants?", options: WORKS_WITH_UK },
      { name: "main_platform", type: "select", label: "Main platform / client type", options: MAIN_PLATFORMS },
    ],
  ],
  submitLabel: "Apply now",
  consent: { variant: "condensed" },
  footer: (
    <p className="text-xs text-brand-grey leading-relaxed" data-testid="partner-form-consent-copy">
      {"By submitting this form, you agree that CanDo Payments may contact you about the Partner Programme. Your details will be handled in line with our "}
      <Link to="/privacy-policy" className="text-brand-aqua-dark hover:text-brand-aqua underline underline-offset-2">
        Privacy Policy
      </Link>
      .
    </p>
  ),
  success: {
    title: "Application received",
    body: "The CanDo Payments team will review your details and contact you shortly.",
  },
  errorMessage: "Something went wrong. Please check your details and try again.",
  summary: (values) =>
    ["Partner Programme application", values.business_type, values.main_platform].filter(Boolean).join(" · "),
  // Landing-page funnel events kept from the previous form.
  events: {
    start: () => analytics.landingEvent("partner_form_start"),
    submit: () => analytics.landingEvent("partner_form_submit"),
    success: () => analytics.partnerLeadSubmitted("partner_programme_application"),
    invalid: () => analytics.landingEvent("partner_form_error", { reason: "validation" }),
    error: () => analytics.landingEvent("partner_form_error", { reason: "request" }),
  },
};

export default partnerApplication;
